export const PRIOR_AUTH_WORKFLOW = "/prior-auth-workflow";
export const CHECK_ELIGIBILITY_WORKFLOW = "/check-eligibility";
export const WELCOME_PAGE = "/"